// extracted by mini-css-extract-plugin
export default {"Root":"HtmlPage_Root__gpY5g","Embedded-Content":"HtmlPage_Embedded-Content__BsKKm"};